import React from "react";
import { useParams } from "react-router-dom";

export default function BlogPost() {
  const { slug } = useParams();

  return (
    <div className="page-content">
      <h1>Blog Post: {slug.replaceAll('-', ' ')}</h1>
      <p>This is a placeholder for the blog content.</p>
    </div>
  );
}
